// extracted by mini-css-extract-plugin
module.exports = {"vfContainer":"e_ss","followed":"e_ts","followedIcon":"e_us","follow":"e_vs","followIcon":"e_ws"};